import ClockSvg from "@Assets/svg/Dashboard-svgs/clock.svg";
import RepeateSvg from "@Assets/svg/Dashboard-svgs/Repeat.svg";
import TestTypeSvg from "@Assets/svg/Dashboard-svgs/Testtype.svg";
import ClassSvg from "@Assets/svg/Dashboard-svgs/Class.svg";
import "./Cards.scss";
import { useNavigate } from "react-router-dom";
import { DetailsRouteURL, TestSereisRouteURL } from "@Constants/app-route-url.constant";
import { Skeleton } from "primereact/skeleton";
import { AppRouteURL, TestRouteURL } from "@Constants/app-route-url.constant";
import { TestTypes } from "@Constants/app.constant";
import { useEffect, useState } from "react";
import SvgIcon from "@Components/icons/SvgIcon";
import { TabView, TabPanel } from 'primereact/tabview';
import { Tooltip } from 'react-tooltip';
import { toOrdinal } from '@Src/utils/toOrdinal';
import { useSubscriptionNavigation } from '@Src/hooks/useSubscriptionNavigation';
import { NoSubscriptionDialog } from '@Components/NoSubscriptionDialog/NoSubscriptionDialog';

import { Dialog } from 'primereact/dialog';
import { FeedbackForm } from "../../../TestResult/components/FeedbackForm/FeedbackForm";
import { getFeedback } from "@Src/features/Dashboard/Service/Dashboard.service";
import { APIStatus } from "@Src/services/baseInterfaces";
import toast from "react-hot-toast";

export const CardDashboardIndex = ({ toggletabs, dashdetails }: any) => {
    const Navigation = useNavigate();
    const [dashboardData, setDashboardData] = useState<any>([]);
    const [showFeedback, setShowFeedback] = useState(false);
    const [currentUserTestId, setCurrentUserTestId] = useState<string>("");
    const [feedbackDetails, setFeedbackDetails] = useState<any>({});
    const { checkSubscriptionAndNavigate, subscriptionDialogProps } = useSubscriptionNavigation();
    const onCickRetry = (testID: number, testtype: number, testDuration: number, testSeriesId: number, examType: number) => {
        let targetUrl = '';
        let stateTransfer: any = {};
        if (testtype == TestTypes.regular) {
            if (examType === 1) {
                if (testSeriesId) {
                    targetUrl = `${TestSereisRouteURL.FULL_MOCK_TEST_SERIES}/${testSeriesId}`;
                    stateTransfer = { flagTest: testSeriesId }
                }
            } else if (examType === 3) {
                if (testSeriesId) {
                    targetUrl = `${TestSereisRouteURL.PREVIOUS_YEAR_MOCK_TEST_SERIES}/${testSeriesId}`;
                    stateTransfer = { flagTest: testSeriesId }
                }
            }
            else {
                if (testSeriesId) {
                    targetUrl = `${TestRouteURL.TEST_SERIES}/${testSeriesId}`;
                    stateTransfer = { flagTest: testSeriesId }
                } else {
                    targetUrl = `${TestRouteURL.TEST}/${testID}`;
                    stateTransfer = { flagTest: testID }
                }
            }
        } else if (testtype == TestTypes.speed) {
            if (examType === 2) {
                if (testSeriesId) {
                    targetUrl = `${TestSereisRouteURL.DIAGNOSTIC_TEST_SERIES}/${testSeriesId}`;
                    stateTransfer = { flagTest: testSeriesId, duration: testDuration }
                }
            } else {
                if (testSeriesId) {
                    targetUrl = `${TestRouteURL.SPEED_TEST_SERIES}/${testSeriesId}`;
                    stateTransfer = { flagTest: testSeriesId, duration: testDuration }
                } else {
                    targetUrl = `${TestRouteURL.SPEED_TEST}/${testID}`;
                    stateTransfer = { flagTest: testID, duration: testDuration }
                }
            }


        }
        checkSubscriptionAndNavigate(targetUrl, undefined, stateTransfer, true);
    }

    useEffect(() => {
        const dashboardInfo = [...dashdetails];
        dashboardInfo.forEach((detail: any) => {
            detail['updatedDate'] = new Date(detail['UpdatedDate']);
        })
        const sortedDashboardInfo = dashboardInfo.sort((dateA: any, dateB: any) => dateB.updatedDate - dateA.updatedDate);
        setDashboardData(sortedDashboardInfo);
    }, [dashdetails])

    const goToTestResult = (details: any) => {
        if (details.TestSeriesId) {
            // Navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TESTRESULT}/${details?.UserId}?examId=${details?.TestSeriesId}&testType=${details?.TestType}&userTestId=${details?.Id}${details.ExamType === 2 ? "&examType=2" : ""}`)
            Navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TESTRESULT}/${details?.UserId}`, { state: { examId: details?.TestSeriesId, testType: details?.TestType, userTestId: details?.Id, examType: details.ExamType === 2 ? "2" : (details.ExamType === 1 ? "1" : (details.ExamType === 3 ? "3" : "")) } })
        } else {
            // Navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TESTRESULT}/${details?.UserId}?testId=${details?.TestId}&testType=${details?.TestType}&userTestId=${details?.Id}${details.ExamType === 2 ? "&examType=2" : ""}`)
            Navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.TESTRESULT}/${details?.UserId}`, { state: { testId: details?.TestId, testType: details?.TestType, userTestId: details?.Id, examType: details.ExamType === 2 ? "2" : (details.ExamType === 1 ? "1" : (details.ExamType === 3 ? "3" : "")) } })
        }
    }
    const getDuration = (durationdata: any) => {
        let hours: any = Math.floor(durationdata / 3600);
        let minutes: any = Math.floor((durationdata - (hours * 3600)) / 60);
        let seconds: any = durationdata - (hours * 3600) - (minutes * 60);

        if (hours > 0) {
            hours = (hours < 10) ? "0" + hours : hours;
        } else {
            hours = '';
        }
        minutes = (minutes < 10) ? "0" + minutes : minutes;
        seconds = (seconds < 10) ? "0" + seconds : seconds;
        let time = hours + (hours ? ":" : '') + minutes + ":" + seconds
        return time;
    }
    const goToLeaderBoard = (details: any) => {
        // const params = new URLSearchParams({
        //     testType: details?.TestType?.toString(),
        //     testName: details?.testName || '',
        //     className: details?.className || ''
        // });
        // if (details.TestSeriesId) {
        //     params.append('examId', details?.TestSeriesId?.toString());
        // } else {
        //     params.append('testId', details?.TestId?.toString());
        // }
        // if (details.ExamType === 2) {
        //     params.append('examType', '2')
        // }


        const stateValue: any = {
            testType: details?.TestType,
            testName: details?.testName,
            className: details?.className,

        }
        if (details.TestSeriesId) {
            stateValue.examId = details?.TestSeriesId;
        } else {
            stateValue.testId = details?.TestId;
        }
        if (details.ExamType === 2) {
            stateValue.examType = '2';
        } else if (details.ExamType === 1) {
            stateValue.examType = '1';
        } else if (details.ExamType === 3) {
            stateValue.examType = '3';
        }
        // Navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.LEADEBOARD}/${details?.UserId}?${params.toString()}`);
        Navigation(`${AppRouteURL.DASHBOARD}${AppRouteURL.LEADEBOARD}/${details?.UserId}`, { state: stateValue })
    }

    const openFeedback = (id: string) => {
        setCurrentUserTestId(id);
        setShowFeedback(true);
    }
    const getFeedbackDetails = async () => {
        // dispatch(showSpinner(true));
        try {
            let param: any = {};
            if (currentUserTestId) {
                param.UserTestId = currentUserTestId;
            }
            const response = await getFeedback(param);
            if (response.ResponseType === APIStatus.SUCCESS && response.data.length > 0) {
                setFeedbackDetails(response.data[0]);
            } else {
                setFeedbackDetails(null);
            }
            // dispatch(showSpinner(false));
        } catch (error) {
            toast.error("Something went wrong while fetching feedback data");
            // dispatch(showSpinner(false));
        }
    }

    useEffect(() => {
        if (currentUserTestId) {
            getFeedbackDetails();
        }
    }, [currentUserTestId])



    const getStyles = (tier: any) => {
        switch (tier) {
            case 'Need More Practice':
                return 'dot dot-poor';
            case 'Improving':
                return 'dot dot-improving';
            case 'Developing':
                return 'dot dot-medium';
            case ' Mastery':
                return 'dot dot-good';
            default:
                return 'dot dot-poor';
        }
    };

    const formatScore = (value: any) => {
        const num = Number(value);
        if (isNaN(num)) return 0;
        return num % 1 === 0 ? num : num.toFixed(2);
    };

    const getPerformanceTier = (scoreInPercentage: number) => {
        if (scoreInPercentage < 30) return 'Need More Practice';
        if (30 <= scoreInPercentage && scoreInPercentage < 50) return 'Improving';
        if (50 <= scoreInPercentage && scoreInPercentage <= 75) return 'Developing';
        if (scoreInPercentage > 75) return ' Mastery';
    };

    return (
        <>
            <table className="table table-auto">
                <thead>
                    <tr>
                        <th className="tw-text-left tw-text-nowrap">Test Name & Date</th>
                        <th>Duration</th>
                        <th className="tw-text-nowrap">Time Spent</th>
                        <th>Marks</th>
                        <th>Score</th>
                        <th>Attempt</th>
                        <th style={{ width: '160px' }}>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {dashboardData && dashboardData.length ? dashboardData.map((details: any) => {
                        // Only show items that match the current tab filter
                        if (Number(details.IsFinalSubmit) !== toggletabs) {
                            return null;
                        }

                        return (
                            <tr key={details.Id}>
                                <td style={{ maxWidth: "30px" }}>
                                    <div className="testname tw-font-semibold">{details?.testName}</div>

                                    {/* <div>{details?.ExamType === 2 ? "Diagnostic" : (details?.ExamType === 1 ? "Full Mock" : (details?.ExamType === 3 ? "Previous Year" : (details?.TestType === 1 ? 'Regular' : "Speed")))} {details.IsFinalSubmit === 1 ? <span className={`tw-inline-flex tw-items-center px-3  tw-border tw-border-grey-800 tw-text-white tw-rounded-3xl tw-mx-2 mb-2 ${getStyles(getPerformanceTier(details.TotalMarks > 0 ? ((details?.OverallScore / details.TotalMarks) * 100) : 0))}`} style={{ fontSize: "14px" }}>
                                        {getPerformanceTier(details.TotalMarks > 0 ? ((details?.OverallScore / details.TotalMarks) * 100) : 0)}
                                    </span> : <></>}</div> */}
                                    <div>{details?.ExamType === 2 ? "Readiness Check" : (details?.ExamType === 1 ? "Mock" : (details?.ExamType === 3 ? "Previous Year" : (details?.TestType === 1 ? 'Practice Smart' : "Speed")))} {details.IsFinalSubmit === 1 ? <span className={`${getStyles(getPerformanceTier(details.TotalMarks > 0 ? ((details?.OverallScore / details.TotalMarks) * 100) : 0))} tw-ml-2`}></span> : <></>}</div>
                                    <div className="tw-text-sm tw-text-gray-500">Class: {details.ClassName} | Language: {details.LanguageName}</div>
                                    <div className="tw-text-sm tw-text-gray-500">{new Date(details?.UpdatedDate).toLocaleDateString('en-GB').replace(/\//g, '-')}</div>

                                </td>
                                <td className="tw-text-center">
                                    {(details?.Duration) / 60} Mins
                                </td>
                                <td className="tw-text-center">
                                    <span>{getDuration(details?.UsedDuration || 0)}</span>
                                </td>
                                <td className="tw-text-center">
                                    {formatScore(details?.TotalMarks)}
                                </td>
                                <td className="tw-text-center">
                                    {formatScore(details?.OverallScore)}
                                </td>
                                <td className="tw-text-center">
                                    {toOrdinal(details?.attempt)}
                                </td>
                                <td className="tw-text-center">
                                    <span className="action-buttons tw-flex tw-items-center tw-justify-center flex-nowrap">

                                        {details.IsFinalSubmit === 1 ? <button type="button"
                                            className="view-detail-btn btn-action btn-view mr-2 mb-0"
                                            data-tooltip-id="dashboard-action-tip"
                                            data-tooltip-content="Review" onClick={() => goToTestResult(details)}><SvgIcon name="view" size={16} style={{ lineHeight: 1 }} /></button> : ''}

                                        {details.IsFinalSubmit === 1 ?
                                            <>
                                                {/* <button type="button"
                                                    className="view-leaderboard-btn btn-action btn-leader mb-0"
                                                    data-tooltip-id="dashboard-action-tip"
                                                    data-tooltip-content="Leaderboard" onClick={() => goToLeaderBoard(details)}> <SvgIcon name="dashboard" size={16} style={{ lineHeight: 1 }} /></button> */}

                                                <button type="button"
                                                    className="view-feedback-btn btn-action btn-star mb-0"
                                                    data-tooltip-id="dashboard-action-tip"
                                                    data-tooltip-content="Feedback"
                                                    onClick={() => openFeedback(String(details.Id))}
                                                >
                                                    <i className="pi pi-star" style={{ fontSize: '16px', lineHeight: 1 }}></i>
                                                </button>
                                            </>
                                            : <button onClick={() => onCickRetry(details.TestId, details?.TestType, details?.Duration / 60, details.TestSeriesId, details.ExamType)}
                                                className="view-resultes-btn active-btn ia-btn ia-btn-primary py-2 px-6">Test </button>}
                                    </span>

                                </td>
                            </tr>
                        )

                    }).filter(Boolean) // Remove null entries
                        : ''
                    }
                </tbody>
            </table>
            <NoSubscriptionDialog {...subscriptionDialogProps} />

            <Dialog
                header={feedbackDetails?.IsFeedback === 1 ? "Your Feedback" : "How was this test?"}
                visible={showFeedback}
                style={{ width: '450px' }}
                onHide={() => setShowFeedback(false)}
                draggable={false}
                resizable={false}
                className="feedback-dialog"
            >
                <FeedbackForm UserTestId={currentUserTestId} isModal={true} />
            </Dialog>
            <Tooltip id="dashboard-action-tip" />
        </>
    )
}



export const SkeletonCardDashboardIndex = () => {
    return (
        <div>
            {[...Array(10)].map((e, i) => (
                <div className="dashboard-card">
                    <Skeleton width="10rem" height="2rem" className="mr-2"></Skeleton>
                    <div className="tw-flex tw-flex-wrap tw-mt-3">
                        <span className="tw-flex tw-items-center">
                            <Skeleton width="1.5rem" height="1.5rem"></Skeleton>
                            <Skeleton width="10rem" className="tw-ml-3"></Skeleton>
                        </span>
                        <span className="tw-flex tw-items-center lg:tw-ml-6">
                            <Skeleton width="1.5rem" height="1.5rem"></Skeleton>
                            <Skeleton width="10rem" className="tw-ml-3"></Skeleton>
                        </span>
                    </div>
                    <div className="tw-flex tw-mt-3 tw-flex-wrap">
                        <span className="tw-flex tw-items-center">
                            <Skeleton width="1.5rem" height="1.5rem"></Skeleton>
                            <Skeleton width="10rem" className="tw-ml-3"></Skeleton>
                        </span>
                        <span className="tw-flex tw-items-center lg:tw-ml-6">
                            <Skeleton width="1.5rem" height="1.5rem"></Skeleton>
                            <Skeleton width="10rem" className="tw-ml-3"></Skeleton>
                        </span>
                    </div>

                    <div className="tw-flex tw-flex-wrap tw-mt-5">
                        <Skeleton width="10rem" height="3rem" className="lg:mr-4"></Skeleton>
                        <Skeleton width="10rem" height="3rem"></Skeleton>
                    </div>
                </div>
            ))}
        </div>
    )
}